/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupseventhastickets3Inputs */

const en_groupseventhastickets3 = /** @type {(inputs: Groupseventhastickets3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets right in the chat`)
};

const de_groupseventhastickets3 = /** @type {(inputs: Groupseventhastickets3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tickets direkt im Chat`)
};

/**
* | output |
* | --- |
* | "Tickets right in the chat" |
*
* @param {Groupseventhastickets3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupseventhastickets3 = /** @type {((inputs?: Groupseventhastickets3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupseventhastickets3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupseventhastickets3(inputs)
	return de_groupseventhastickets3(inputs)
});
export { groupseventhastickets3 as "groupsEventHasTickets" }